import React, { useState, useEffect } from "react";
import "./index.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import {
  getVehicleListAction,
  clearAllFleets,
} from "../../../../services/Store/Actions/manageVehicleAction";
import AddNewCustomerButtonV2 from "../../../../Subcomponent/AddCustomerButtonV2";
import SearchBar from "../../../subComponents/searchbar/index";
import ManageVehicleDetailsCard from "../ManageVehicleDetailsCard/index";
import AddNewVehicleModal from "../../../Modals/addNewVehicle/index";
import { Table } from "reactstrap";
import { useSearchParams } from "react-router-dom";
import SvgImage from "../../../Icons/Icons";
import { sendAnalitics } from "../../../../services/Store/Actions/appActions";
import {
  cleanFleet,
  getFleetTracker,
} from "../../../../services/Store/Actions/driverslistActions";
import SettingsInputHdmiIcon from "@mui/icons-material/SettingsInputHdmi";

import Requests from "../../../Modals/Requests";
import { useNavigate } from "react-router-dom";
import { cleanGpsLastLocationData, getGpsLastLocationAction } from "../../../../services/Store/Actions/fleetActions";
import LocationTimeline from "../LocationTimeline";
function FullVehicleList(props) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const { openStatus,
    setOpenStatus,selection,
    setSelection } = props;
  const [show, setShow] = useState(false);
  const [btn, setBtn] = useState(false);
  // const [search, setSearch] = useState("");
  const [proceed, setProceed] = useState(0);
  const [fstOpen, setFstOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(1);
  const [assignedStatus, setAsssignedStatus] = useState(3);
  const { allFleets, allFleetsList } = useSelector(
    (state) => state?.manageVehicle
  );
  const [windowWidth, setWindowWidth] = useState("");

  const { advancedVehicleList, advancedVehicleListCount } = useSelector(
    (state) => state?.fleet
  );
  const { allFleetTrackerList, loader, allFleetTracker } = useSelector(
    (state) => state?.driverlist
  );
  function toggleModal() {
    setOpen(!open);
    setProceed(0);
  }

  useEffect(()=>{
    console.log("ghjhghjkjhghj")
    dispatch(getGpsLastLocationAction({},(res)=>{
      console.log("gpslastlocation",res);
    }))
    return function cleanUp() {
      dispatch(cleanGpsLastLocationData());
    };
  },[])

  // const handleUserId = (val) => {
  //   handleUser(val);
  //   //onsole.log("useState change ho rha hai kya yahi ", val);
  // };

  const urlSearchParams = new URLSearchParams(window.location.search);

  const params = Object.fromEntries(urlSearchParams.entries());
  // console.log("url split", searchParam);

  let searchParam = params.search;

  console.log("url split", searchParam);

  const [search, setSearch] = useState(
    searchParam == undefined ? "" : searchParam
  );

  const { gpsStatus, gpsData } = useSelector((state) => state?.fleet);

  const [allVehicle, setAllVehicle] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  console.log("sbjsjsbsjs", gpsData, allVehicle);

  useEffect(() => {
    console.log("initialisingdataaaa");
    const initialData =
      gpsData?.data?.data?.slice(0, 10) || gpsData?.data?.slice(0, 10);
    setAllVehicle(initialData);
    setStartIndex(0)
  }, [gpsData]);

  const addNext10Data = () => {
    const nextIndex = startIndex + 10;
    console.log("nextdataaaa1", nextIndex);
    console.log(
      "nextdataaaa2",
      gpsData?.data?.data?.slice(nextIndex, nextIndex + 10)
    );
    let nextData;
    if (gpsData?.data?.data) {
      nextData = gpsData?.data?.data?.slice(nextIndex, nextIndex + 10);
    } else {
      nextData = gpsData?.data?.slice(nextIndex, nextIndex + 10);
    }
    console.log("nextdataaaa2", nextData,nextIndex);
    setAllVehicle(nextData);
    setStartIndex(nextIndex);
  };

  const addPrevious10Data = () => {
    const prevIndex = Math.max(0, startIndex - 10);
    console.log("nextdataaaa1", prevIndex);
    let prevData;
    if (gpsData?.data?.data) {
      prevData = gpsData?.data?.data.slice(prevIndex, prevIndex + 10);
    } else {
      prevData = gpsData?.data.slice(prevIndex, prevIndex + 10);
    }
    setAllVehicle(prevData);
    setStartIndex(prevIndex);
  };

  const offsetString =
    window.location.search === "" ? 0 : window.location.search.split("=")[2];
  const offsetVal = Number(offsetString);
  const [offset, setOffset] = useState(offsetVal);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dispatch = useDispatch();
  const [rechargeRank, setRechargeRank] = useState(0);
  const findSearch = () => {

    if (search != "") {
      console.log("change in search", search);
      const filteredData =
        gpsData?.data?.data?.filter((vehicle) =>
          JSON.stringify(vehicle).includes(search)
        ) ||
        gpsData?.data?.filter((vehicle) =>
          JSON.stringify(vehicle).includes(search)
        );
      console.log("fileee", filteredData);
      setAllVehicle(filteredData?.slice(0, 10));
      setStartIndex(0); // Reset to the beginning of the filtered data
    }
    else if(search == ""){
      const initialData = gpsData?.data?.data?.slice(0, 10) || gpsData?.data?.slice(0, 10);
      setAllVehicle(initialData);
      setStartIndex(0)
    }
  };

  useEffect(() => {
    if (search != "") {
      console.log("change in search", search);
      const filteredData =
        gpsData?.data?.data?.filter((vehicle) =>
          JSON.stringify(vehicle).includes(search)
        ) ||
        gpsData?.data?.filter((vehicle) =>
          JSON.stringify(vehicle).includes(search)
        );
      console.log("fileee", filteredData);
      setAllVehicle(filteredData?.slice(0, 10));
      setStartIndex(0); // Reset to the beginning of the filtered data
    }
    else if(search == ""){
      const initialData = gpsData?.data?.data?.slice(0, 10) || gpsData?.data?.slice(0, 10);
      setAllVehicle(initialData);
      setStartIndex(0)
    }
  }, [search,gpsData?.data]);

  const handleClose = () => {
    setOpen(false);
    setProceed(0);
  };
  const handleShow = () => {
    dispatch(sendAnalitics("AddVeh_MV_FW_Web"));
    setOpen(true);
    //console.log("sdsdsdsdsdsdddddddddd");
  };

  useEffect(() => {
    dispatch(sendAnalitics("MV_FW_Web"));
    return function cleanUp() {
      dispatch(clearAllFleets());
      setOffset(0);
      dispatch(clearAllFleets());
    };
  }, []);

  function handleClick(data) {
    props.handleUser(data.Fastag.fleetId);
    //console.log("new Meta ",)
    props.handleFastagBal(data.Fastag.balance);
    props.handleTagId(data.Fastag.tagId);
    props.handleRegNo(data.regNumber);
    //console.log("single fleet data",data)
  }
  //console.log("NEWMOON",Data[0].regNumber)

  const [openLink, setOpenLink] = useState(false);
  const [fleetId, setFleetId] = useState("");
  const [vehCat, setVehCat] = useState("1");
  const [regNumber, setRegNumber] = useState("");
  const [color, setColor] = useState(-1);

  // auto recharge specific vehicle

  const [showroomModal, setShowroomModal] = useState(false);
  const [showRequest, setshowRequest] = useState(false);

  const showRequests = () => {
    console.log("invoiceModal", showroomModal);
    setshowRequest(!showRequest);
  };
  const vehiclehistory = () => {
    navigate("/VehicleHistory", {
      state: {
        path: "all",
      },
    });
  };

  const { fastagWallet } = useSelector((state) => state?.fastag);
  console.log("-----------------", fastagWallet);
  const autoRechargeState = fastagWallet?.autoRecharge;

  const counting = advancedVehicleListCount;
  return (
    <div className="row">
          <div className={openStatus == regNumber ? "FullGpsListBox col-7" : "FullGpsListBox col-12"}>
      <div className="FullCustomerListTopBoxV2">
        <div
          className="FullCustomerListHeader fontNB20 col-6"
          style={{ textAlign: "center" }}
        >
          GPS Tracking
        </div>

        <div className="col-6" style={{textAlign: "end"}}>
        <div>
            <input
              type="button"
              className="greenButton Medium text3"
              value={"All Location"}
              style={{
                width: "100px",
                marginBottom: "10px",
                // backgroundColor: Selection ? "#ed752e" : "white",
                background: selection == "0" ? "#ed752e" : "#485b7c",
                marginLeft: "10px",
                // boxSizing: "border-box",
                // border: "1px solid #96a9ca",
                // borderRadius: "4px",
              }}
              onClick={() => {
                console.log("selection...", selection);
                props.allowTrigger();
                props.setVehRank(-1);
                setRegNumber(-1);
                navigate(`/GPS`);
                setColor(-1);
                setSelection("0");
                // navigate(`/GPS`);
              }}
            />
          </div>
        </div>
      </div>
      <div
        onClick={() => {
          props?.setIsGPSCard(!props?.isGPSCard);
        }}
        className="col-12"
        style={{
          background: props?.isGPSCard ? "#485B7C" : "#fff",
          alignItems: "center",
          placeContent: "center",
          color: props?.isGPSCard ? "white" : "black",
          height: "50px",
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        Plugin GPS integration
        <SettingsInputHdmiIcon />
      </div>
      {
        <>
          <div className="FUllListSearchBar">
            <SearchBar
              placeholder="Search for vehicles"
              height="40"
              value={search}
              setSearch={setSearch}
              onChange={(event) => {
                //dispatch(clearAllDrivers());
                dispatch(
                  sendAnalitics("SearchBar_MV_FW_Web", {
                    searchVeh: event.target.value,
                  })
                );
                setSearch(event.target.value);
              }}
              findSearch={findSearch}
            />
          </div>


          <div className="customer-list scroll" style={{ marginTop: "15px",overflow:"scroll", height: "400px" }}>
            <ManageVehicleDetailsCard
              search={search}
              offset={offset}
              setOffset={setOffset}
              nextTrigger={props.nextTrigger}
              allowTrigger={props.allowTrigger}
              openLink={openLink}
              setOpenLink={setOpenLink}
              fleetId={fleetId}
              setFleetId={setFleetId}
              vehCat={vehCat}
              setVehCat={setVehCat}
              regNumber={regNumber}
              setIsGPSCard={props?.setIsGPSCard}
              setRegNumber={setRegNumber}
              color={color}
              setColor={setColor}
              setVehRank={props.setVehRank}
              activeStatus={activeStatus}
              assignedStatus={assignedStatus}
              selection={selection}
              setSelection={setSelection}
              allVehicle={allVehicle}
              addNext10Data={addNext10Data}
              addPrevious10Data={addPrevious10Data}
              startIndex={startIndex}
              openStatus={openStatus}
setOpenStatus = {setOpenStatus}
            ></ManageVehicleDetailsCard>
          </div>

          <AddNewVehicleModal
            open={open}
            onHide={handleClose}
            toggleModal={toggleModal}
            setOffset={setOffset}
            setRegNumber={setRegNumber}
            setVehCat={setVehCat}
            setFleetId={setFleetId}
            setColor={setColor}
            search={search}
            setOpenLink={setOpenLink}
          />
        </>
      }
          </div>
          {openStatus == regNumber ?           <div className={"FullGpsListBox col-5"} style={{padding: 0}}>
          <div
          className="row align-items-end"
          style={{ margin: "15px 0 0 0px" }}
        >
          <div className= "row" style={{padding: 0}}>
            <div className="col-10 d-flex">
            <button className="ButtonGlobal" style={{width : "78px"}}>
              {selection == "2" ? "Timeline" : "Trip"}
            </button>
            {/* <button className="ButtonGlobal" style={{width : "78px"}}>
              Trip
            </button> */}
              </div>
            <div className="col-2 " style={{    border: "1px solid",
    borderRadius: "20px",
    background: "#ffffff",
    cursor: "pointer",
    
    padding: "4px 0px 0 1px"
}}
onClick={() => {
  setOpenStatus("")
  setSelection("1")
}}
>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
              </div>

          </div>
          <LocationTimeline  vrn = {regNumber}/>

  
        </div>
          </div> : <></>}
          
    </div>
  );

  // return (
  //   <div className="FullVehicleListBox">
  //     <div className="FullVehiclesListTopBox">
  //       <div className="FullVehiclesListHeader">Full Vehicles List</div>
  //       <div className="FullVehiclesListAddButton" onClick={handleShow}>
  //         <AddNewCustomerButton name="Add New Vehicle" />
  //         {
  //           <AddNewVehicleModal
  //             open={open}
  //             onHide={handleClose}
  //             toggleModal={toggleModal}
  //           />
  //         }
  //       </div>
  //     </div>
  //     <div className="FullVehiclesListSearchBar">
  //       <SearchBar
  //         placeholder="Search for Vehicles"
  //         height="46"
  //         findSearch={findSearch}
  //         onChange={(event) => {
  //           //dispatch(clearAllFleets());
  //           setSearch(event.target.value);
  //         }}
  //       />
  //     </div>
  //     <div className=""></div>
  //     <div className="FullVehicleDetailsListBar">
  //       <ManageVehicleListBar />
  //     </div>
  //     <div className="FullVehicleDetailsList_driverListTable">
  //       <div>
  //         <ManageVehicleDetailsCard
  //           //handleUserId={handleUserId}

  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
}
export default FullVehicleList;
